/*
 * Copyright Mimic Networks, Inc. 2024.
 */

import { NodeViewCard } from '@/primitives/NodeViewCard';

export type NodeViewPageCardProps = {
  title?: string;
  children: React.ReactNode;
  dataTestId?: string;
  bodyStyles?: React.CSSProperties;
  style?: React.CSSProperties;
};

export function NodeViewPageCard({ title, children, dataTestId, bodyStyles, style }: NodeViewPageCardProps) {
  return (
    <NodeViewCard title={title} gap="xxs" dataTestId={dataTestId} bodyStyles={bodyStyles} style={style}>
      {children}
    </NodeViewCard>
  );
}
